// extracted by mini-css-extract-plugin
export default {"userMenu":"UserMenu_userMenu__8+hhz","iconButton":"UserMenu_iconButton__TJd8U","popup":"UserMenu_popup__RQtRz","disabled":"UserMenu_disabled__Kaky3"};